var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getClassName("colors") }, [
    _vm.getColors.length > 0
      ? _c(
          "ul",
          { class: _vm.getClassName("colors__items") },
          [
            _vm._l(_vm.getColors, function(color) {
              return [
                !_vm.simulation || (_vm.simulation && color.simulation_image)
                  ? _c(
                      "li",
                      {
                        key: _vm.uuid + "-" + color.id,
                        class: _vm.getClassName("colors__item")
                      },
                      [
                        _c(
                          "label",
                          {
                            class: _vm.getClassNameActive(
                              "colors__action",
                              color,
                              _vm.value.item_color_id
                            ),
                            attrs: { for: _vm.uuid + "-" + color.id }
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                src: color.thumbnail,
                                alt: color.name,
                                width: _vm.media ? "66" : "78",
                                height: _vm.media ? "66" : "78"
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.internalValue,
                                  expression: "internalValue"
                                },
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              attrs: {
                                type: "radio",
                                id: _vm.uuid + "-" + color.id
                              },
                              domProps: {
                                value: color.id,
                                checked: _vm._q(_vm.internalValue, color.id)
                              },
                              on: {
                                change: function($event) {
                                  _vm.internalValue = color.id
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.items.length > 1
                          ? _c(
                              "div",
                              { class: _vm.getClassName("colors__name") },
                              [_vm._v(_vm._s(color.item.name))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { class: _vm.getClassName("colors__name") }, [
                          _vm._v(_vm._s(color.name))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }